import React from "react";
// import { Layout } from "../components/layout/Layout";
import RegisterForm from "./../components/forms/RegisterForm/RegisterForm"

const RegisterPage = ()=>{
    return(
        <>
    <div className="parentdiv mb-20">
        
        {/* <Layout> */}
            <RegisterForm />
    </div>
        {/* </Layout> */}
        </>
    )
}
export {RegisterPage}